export default function handleSEO (response) {
  if (response.data.meta.seoHtml) {
    document.head
      .querySelectorAll('[data-seo-item]')
      .forEach(node => node.remove());

    document.head
      .insertAdjacentHTML('beforeend', response.data.meta.seoHtml);
  }

  return response;
}
